/**
 * DUNAMIS WEAR — Predictive Search
 */
(function () {
  'use strict';
  const theme = window.theme;

  const overlay = document.getElementById('SearchOverlay');
  const input = document.getElementById('SearchInput');
  const results = document.getElementById('SearchResults');

  if (!overlay) return;

  const debouncedSearch = theme.debounce(function (query) {
    if (query.length < 2) {
      results.innerHTML = '';
      return;
    }
    fetch(theme.routes.predictive_search_url + '?q=' + encodeURIComponent(query) + '&resources[type]=product,collection&resources[limit]=6')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        let html = '';
        const products = data.resources?.results?.products || [];
        const collections = data.resources?.results?.collections || [];
        if (products.length === 0 && collections.length === 0) {
          html = '<p class="search-overlay__empty">' + (theme.strings.noResults || 'Nenhum resultado encontrado.') + '</p>';
        } else {
          products.forEach(function (p) {
            html += '<a href="' + p.url + '" class="search-result"><img src="' + (p.image || '') + '&width=80" alt="" width="60"><span>' + p.title + '</span></a>';
          });
          collections.forEach(function (c) {
            html += '<a href="' + c.url + '" class="search-result search-result--collection"><span>' + c.title + '</span></a>';
          });
        }
        results.innerHTML = html;
      });
  }, 300);

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-search-toggle]')) {
      e.preventDefault();
      overlay.classList.add('is-open');
      overlay.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      input && input.focus();
    }
    if (e.target.closest('[data-search-close]')) {
      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
  });

  if (input) {
    input.addEventListener('input', function () { debouncedSearch(input.value.trim()); });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlay.classList.contains('is-open')) {
      overlay.classList.remove('is-open');
      document.body.style.overflow = '';
    }
  });

  window.__predictiveSearchReady = true;
})();
